'use strict';

module.exports = angular.module('lipsApp.translation', ['pascalprecht.translate', 'ngCookies']).config(function ($translateProvider) {
    $translateProvider.useStaticFilesLoader({
        prefix: '/app/translation/resources/',
        suffix: '.json'
    }).translations('rus', require('./resources/rus.json')).translations('est', require('./resources/est.json')).translations('eng', require('./resources/eng.json')).useSanitizeValueStrategy('sanitizeParameters').preferredLanguage('est').fallbackLanguage('est');
}).run(function ($rootScope, $translate, supportedLanguages) {
    if (_.some(supportedLanguages, function (x) {
        return x.code == CURRENT_LANGUAGE;
    })) {
        $translate.use(CURRENT_LANGUAGE);
    }

    $rootScope.getCurrentUiLanguageName = function () {
        var lang = $translate.proposedLanguage() || $translate.use();
        return _.get(_.find(supportedLanguages, { code: lang }), 'name', '');
    };
    $rootScope.getCurrentUiLanguageCode = function () {
        return $translate.proposedLanguage() || $translate.use();
    };
}).constant('supportedLanguages', [{ code: 'rus', name: 'RUS' }, { code: 'est', name: 'EST' }, { code: 'eng', name: 'ENG' }]);


/** WEBPACK FOOTER **
 ** ./app/translation/translation.module.js
 **/